import _ from 'lodash'
import moment from 'moment'
import 'mutationobserver-shim'
import jQuery from 'jquery'
import VeeValidate from 'vee-validate'
import VShowSlide from 'v-show-slide'
import Vue from 'vue'
import VueResource from 'vue-resource'
import VueSession from 'vue-session'
import VueSweetalert2 from 'vue-sweetalert2'
import numeral from 'numeral'
import VueTheMask from 'vue-the-mask'
import VueSignature from 'vue-signature'
import Fragment from 'vue-fragment'
import PortalVue from 'portal-vue'
import { directive as onClickOutside } from 'vue-on-click-outside'

import App from './App'
import router from './router'
import store from './store'

// import 'promise-polyfill/src/polyfill';
import IdleVue from 'idle-vue'
import JsonExcel from 'vue-json-excel'

global.jQuery = jQuery
global.$ = jQuery

let bootstrap = require('bootstrap')
require('./assets/js/bootstrap-datepicker-thai/js/bootstrap-datepicker.js')
require('./assets/js/bootstrap-datepicker-thai/js/bootstrap-datepicker-thai.js')
require('./assets/js/bootstrap-datepicker-thai/js/locales/bootstrap-datepicker.th.js')

Object.defineProperty(Vue.prototype, '_', { value: _ })
Object.defineProperty(Vue.prototype, 'moment', { value: moment })

Vue.config.productionTip = false
Vue.use(VueSession, { persist: true })
Vue.use(VeeValidate, { errorBagName: 'vErrors' })
Vue.use(VueResource)
Vue.use(VueSweetalert2)
Vue.use(VShowSlide, {
  customEasing: {
    exampleEasing: 'cubic-bezier(0.68, -0.55, 0.265, 1.55)',
  },
})

Vue.filter('formatNumber', value => {
  return numeral(value).format('0,0')
})

Vue.use(VueTheMask)
Vue.use(VueSignature)
Vue.use(Fragment.Plugin)
Vue.use(PortalVue)

Vue.directive('on-click-outside', onClickOutside)

const eventsHub = new Vue()

Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 900000, //15minute=900000
})

new Vue({
  router,
  store,
  jQuery,
  IdleVue,
  render: h => h(App),
}).$mount('#app')
